<template>
  <div class="bottom-charts">
    <div id="year" style="height: 100%;width: 100%">

    </div>
  </div>
</template>

<script>

import * as echarts from 'echarts'

export default {
  name: 'BottomCharts',
  props: {
    monthCount: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    monthCount: {
      deep: true,
      handler () {
        this.setOption()
      }
    }
  },
  beforeDestroy () {
    this.echarts && this.echarts.dispose()
  },
  data () {
    return {
      echarts: null
    }
  },
  mounted () {
    this.echarts = echarts.init(document.getElementById('year'))
    this.setOption()
  },
  methods: {
    setOption () {
      let options = {
        tooltip:{
          show:true
        },
        color: ['#20B9FA'],
        xAxis: {
          type: 'category',
          data: Object.keys(this.monthCount)
        },
        yAxis: {
          type: 'value'
        },
        title: {
          backgroundColor: '#333'

        },
        series: [
          {
            data: Object.values(this.monthCount),
            type: 'bar'
          }
        ]
      }
      this.echarts.setOption(options)
    }
  }
}
</script>

<style lang="less">
.bottom-charts {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;

  .bc-chart-item {
    width: 25%;
    height: 100%;
    padding-top: 20px;
    box-sizing: border-box;
  }

  .bcci-header {
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 20px;
  }

  .dv-active-ring-chart {
    height: calc(~"100% - 80px");
  }

  .label-tag {
    height: 30px;
  }

  .active-ring-name {
    font-size: 18px !important;
  }

  .decoration-1, .decoration-2, .decoration-3 {
    display: absolute;
    left: 0%;
  }
}
</style>
